// extracted by mini-css-extract-plugin
module.exports = {"Header":"Header_Header__3Jg8c","Image":"Header_Image__3ssgU"};